import { render, staticRenderFns } from "./SyncStatsContainer.vue?vue&type=template&id=0ff7a324&"
import script from "./SyncStatsContainer.vue?vue&type=script&lang=js&"
export * from "./SyncStatsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports